import React, { Component } from 'react'
import { Button, ModalHeader, ModalBody, ModalFooter, Form, FormGroup } from 'reactstrap'
import RichTextEditor from '../../components/RichTextEditor'
import Resource from '../../Resource'
import { closeModal } from '../../reducers/modals'

import '../../styles/StudyContainer.css'
import { MultiSelect } from 'react-multi-select-component'
import * as Inputs from '../../participant/Inputs'

export default class StudyContainer extends Component {
  constructor(props) {
    super(props)

    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    var yyyy = today.getFullYear()
    console.log(props)
    this.state = Object.assign(
      {
        name: '',
        description: '',
        startDate: '',
        endDate: '',
        selectedOptions: props.study ? props.study.users.map(this.mapUserOptions) || [] : [],
        selectedUserIds: props.study ? props.study.users.map((user) => user.id) || [] : [],
      },
      props.study || {}
    )
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false
  }

  onCancel = () => {
    this.props.dispatch(closeModal())
  }

  onFinish = async () => {
    console.log(this.state)
    const { json, response } = await this.props.onSave(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  onDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this study?')) {
      return
    }
    const { json, response } = await this.props.onDelete(this.state)
    if (!this._mounted) return false
    if (response.status === 200) {
      this.props.dispatch(closeModal())
    } else {
      this.setState({ error: json.error })
    }
  }

  onParticipantsSelected = (e) => {
    console.log(e)
    this.setState({ selectedOptions: e, selectedUserIds: e.map((option) => option.value) })
  }

  mapUserOptions = (user) => {
    return {
      value: user.id,
      label: user.firstName + ' ' + user.lastName,
    }
  }

  render() {
    const verb = this.props.post ? 'Edit' : 'Create a'
    const { error, name, startDate, endDate, selectedOptions, description } = this.state
    let valid = name && startDate && endDate && selectedOptions

    const options = [
      { label: 'Grapes 🍇', value: 'grapes' },
      { label: 'Mango 🥭', value: 'mango' },
      { label: 'Strawberry 🍓', value: 'strawberry', disabled: true },
    ]

    const sortUsers = (users) => {
      let filteredUsers = users
      if (this.props.me.role === 2) {
        filteredUsers = users.filter((user) => user.trainerId === this.props.me.id)
      }
      return filteredUsers
    }

    return (
      <div className="PostModalContainer">
        <ModalHeader toggle={this.onCancel}>{verb} Study</ModalHeader>
        <div className="row">
          <div className="col-md-12">
            <ModalBody>
              {error && <div className="alert alert-danger">{error}</div>}
              <Form>
                <label>Study Name:</label>
                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        type="text"
                        id="name"
                        value={name}
                        placeholder="Study Name"
                        onChange={(e) => this.setState({ name: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <label>Start Date:</label>
                      <Inputs.Date
                        style={{ flex: 1, marginRight: 20 }}
                        value={this.state.startDate}
                        onChange={(value) => this.setState({ startDate: value })}
                      />
                    </div>
                  </div>
                </FormGroup>

                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <label>End Date:</label>
                      <Inputs.Date
                        style={{ flex: 1, marginRight: 20 }}
                        value={this.state.endDate}
                        onChange={(value) => this.setState({ endDate: value })}
                      />
                    </div>
                  </div>
                </FormGroup>
                <Resource collection path={['users']} placeholder={[]}>
                  {(users) => (
                    <FormGroup>
                      <div className="row">
                        <div className="col-md-12">
                          <label>Participants:</label>
                          <MultiSelect
                            options={users.map(this.mapUserOptions)}
                            onChange={this.onParticipantsSelected}
                            value={this.state.selectedOptions}
                            labelledBy="Select"
                          />
                        </div>
                      </div>
                    </FormGroup>
                  )}
                </Resource>

                <label>Description:</label>
                <FormGroup>
                  <div className="row">
                    <div className="col-md-12">
                      <input
                        className="form-control"
                        type="text"
                        id="name"
                        value={description}
                        placeholder="Description"
                        onChange={(e) => this.setState({ description: e.target.value })}
                      />
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </ModalBody>
          </div>
        </div>
        <ModalFooter>
          {this.props.onDelete ? (
            <Button className="btn btn-danger" onClick={this.onDelete}>
              Delete
            </Button>
          ) : null}
          <div style={{ flex: 1 }} />
          <Button className="btn btn-primary" onClick={this.onFinish} disabled={!valid}>
            Save
          </Button>
        </ModalFooter>
      </div>
    )
  }
}
